export class Globals {
    public static themes: string[ ] = ['light', 'dark'];
    public static theme: string = 'dark';
}



// WEBPACK FOOTER //
// /app/src/app/shared/globals/globals.ts